// src/modules/admin/components/AdminSidebar/index.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../../shared/hooks/useAuth';
import './styles.css';

const stravaEnabled = process.env.REACT_APP_FEATURE_STRAVA === 'true';

const AdminSidebar = () => {
    const { hasPermission } = useAuth();

    const navItems = [
        { label: 'Dashboard', icon: 'bi-speedometer2', path: '/admin' },
    ];

    const managementItems = [
        { label: 'Users', icon: 'bi-people', path: '/admin/users', permission: 'users:managePermissions' },
        { label: 'Exemptions', icon: 'bi-check-circle', path: '/admin/exemptions', permission: 'activities:handleExemptions' },
    ].filter(item => !item.permission || hasPermission(item.permission));

    const contentItems = [
        { label: 'Competitions', icon: 'bi-trophy', path: '/admin/competitions', anyPermission: ['competition:create', 'competition:edit'] },
        { label: 'Activities', icon: 'bi-list-ul', path: '/admin/activities', permission: 'activities:writeAny' },
    ].filter(item => {
        if (item.anyPermission) return item.anyPermission.some(hasPermission);
        return !item.permission || hasPermission(item.permission);
    });

    const integrationItems = [
        ...(stravaEnabled ? [{ label: 'Strava', icon: 'bi-arrow-clockwise', path: '/admin/strava', anyPermission: ['strava:resync', 'strava:viewAthletes'] }] : []),
    ].filter(item => {
        if (item.anyPermission) return item.anyPermission.some(hasPermission);
        return !item.permission || hasPermission(item.permission);
    });

    const renderSection = (items, sectionLabel) => {
        if (items.length === 0) return null;
        return (
            <>
                {sectionLabel && <div className="sidebar-section-header">{sectionLabel}</div>}
                {items.map(item => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className="sidebar-link"
                        end={item.path === '/admin'}
                    >
                        <i className={`bi ${item.icon}`}></i>
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </>
        );
    };

    return (
        <aside className="admin-sidebar">
            <div className="sidebar-brand">
                <i className="bi bi-shield-lock"></i>
                <span>Admin</span>
            </div>
            <nav className="sidebar-nav">
                {renderSection(navItems)}
                {renderSection(managementItems, 'Management')}
                {renderSection(contentItems, 'Content')}
                {renderSection(integrationItems, 'Integrations')}
            </nav>
        </aside>
    );
};

export default AdminSidebar;
